export default __webpack_public_path__ + "img/jSntAAkR.c3fba61b.svg";